'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FormattedFaxNumber = _react2['default'].createClass({
    displayName: 'FormattedFaxNumber',


    propTypes: {
        faxNumber: _react2['default'].PropTypes.string.isRequired
    },

    componentWillMount: function componentWillMount() {
        var formattedFaxNumber = hellofaxJS.formatInternationalFaxNumber(this.props.faxNumber);
        this.setState({ formattedFaxNumber: formattedFaxNumber });
    },
    render: function render() {
        return _react2['default'].createElement(
            'span',
            { className: 'fax-number' },
            this.state.formattedFaxNumber
        );
    }
});
module.exports = FormattedFaxNumber;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/formatted-fax-number.jsx
 ** module id = 1205
 ** module chunks = 0
 **/